import { t } from "@/i18n";
import { getPermissionLabel } from "./labels";

const groups: Record<string, string[]> = {
  companies: ["COMPANY_CREATE", "COMPANY_EDIT", "COMPANY_DEACTIVATE"],
  users: [
    "USER_CREATE",
    "USER_EDIT",
    "USER_DEACTIVATE",
    "USER_VIEW_TENANT",
    "USER_EDIT_TENANT",
  ],
  categories: [
    "DOCUMENT_CONSTRUCTOR_CREATE",
    "DOCUMENT_CONSTRUCTOR_EDIT",
    "DOCUMENT_CONSTRUCTOR_DEACTIVATE",
  ],
  documents: [
    "DOCUMENT_TEMPLATE_CREATE",
    "DOCUMENT_TEMPLATE_EDIT",
    "DOCUMENT_TEMPLATE_DEACTIVATE",
    "DOCUMENT_BATCH_CREATE",
    "DOCUMENT_ACCESS_CO_EDITOR_GRANT",
  ],
  coordination: ["ENTITY_APPROVAL_COORDINATE"],
  reports: ["REPORT_CREATE", "REPORT_EDIT"],
  hr: [
    "HR_VIEW",
    "HR_EMPLOYEE_EDIT",
    "HR_DOCUMENT_MANAGE",
    "HR_SETTINGS_MANAGE",
  ],
  assistant: [
    "HR_ASSISTANT_EMPLOYEE_SEARCH",
    "HR_ASSISTANT_EMPLOYEE_VIEW",
    "HR_ASSISTANT_DOCUMENT_SEARCH",
    "HR_ASSISTANT_DOCUMENT_VIEW",
    "HR_ASSISTANT_FILE_VIEW",
  ],
  helpdesk: ["HELPDESK_MANAGE"],
  appearance: ["UI_DARK_THEME"],
  enbek: ["ENBEK_MANAGE"],
};

interface PermissionGroup {
  key: string;
  label: string;
  permissions: { value: string; label: string }[];
}

export function getPermissionGroups(selected?: string[]): PermissionGroup[] {
  const entries = Object.entries(groups);
  if (selected) {
    const known = new Set(entries.flatMap(([, permissions]) => permissions));
    entries.push([
      "other",
      selected.filter((permission) => !known.has(permission)),
    ]);
  }
  return entries
    .map(([key, permissions]) => ({
      key,
      label: t(`rolePermissions.${key}`),
      permissions: permissions
        .filter((permission) => !selected || selected.includes(permission))
        .map((value) => ({ value, label: getPermissionLabel(value) })),
    }))
    .filter((group) => group.permissions.length);
}
